const Timeline = ({ initCred, credits, summe }) => {
  let count = 0;

  return (
    <div className="container-timeline career-item">
      <table className="timeline" data-count={credits.length + 2}>
        <thead>
          <tr>
            <th className="main-cell">Initial</th>
            {credits.map((data) => {
              count++;
              return <th key={count}>{data.jahr}</th>;
            })}
            <th className="main-cell">Summe</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="main-cell">{initCred}</td>
            {credits.map((data) => {
              count++;
              return <td key={count}>{data.credits}</td>;
            })}
            <td className="main-cell">{summe}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Timeline;
